import React from 'react'

const serverUrlImages = process.env.REACT_APP_SERVER_URL_IMAGES;
const protectedIcon = `${serverUrlImages}/icons/benefits-page/protegido.svg`;

function ProtectComponent() {

    return (
        <div className="container flex flex-col sm:flex-row rounded border border-gray-300 mb-6 px-6 py-8">
          <div>
            <span className="flex align-center justify-center h-16 w-16 sm:ml-7 sm:mr-14 m-auto mb-7">
              <img
                loading="lazy"
                src={protectedIcon}
                alt="icono"
                className="max-w-none"
              />
            </span>
          </div>
          <div className="informative-text">
            <h3 className="text-3xl text-purple-500 font-bold font-poppins mb-6">
              ¡Tu también estás protegido!
            </h3>
            <p className="leading-relaxed text-gray-800 text-base font-poppins">
              Si contratas  <span className="text-pink-500 font-bold font-poppins">asistensi</span> para tus
              familiares en casa tu también podrás beneficiarte. Descarga nuestra App asistensi y
              consulta a nuestros médicos dominicanos de forma gratuita e ilimitada desde cualquier
              parte del mundo. Podrás recibir indicaciones para cuidar tu salud, sin importar dónde
              estés.
            </p>
          </div>
        </div>
    )
}

export default ProtectComponent
